import 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { selectFromTheme, selectFromMap, selectFromProps, stylesFromMap } from '@thisisbud/sc-utils';
import { jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t;
const avatarClassName = 'bui-avatar';
const avatarImgClassName = `${avatarClassName}__img`;

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledSpan = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledSpan",
  componentId: "sc-1s3ihm6-0"
})(_t || (_t = _`
  display: inline-block;
  box-sizing: border-box;
  border-style: solid;
  background-color: ${0};
  border-color: ${0};
  border-width: ${0};
  overflow: hidden;
  ${0}
  ${0}

  .${0} {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`), selectFromTheme('colorBackgroundAvatar'), selectFromTheme('colorBorderAvatar'), selectFromTheme('borderWidthAvatarDefault'), selectFromMap(selectFromProps('$size'), {
  'large': stylesFromMap({
    height: selectFromTheme('sizeAvatarLargeDefault'),
    width: selectFromTheme('sizeAvatarLargeDefault')
  }),
  'regular': stylesFromMap({
    height: selectFromTheme('sizeAvatarRegularDefault'),
    width: selectFromTheme('sizeAvatarRegularDefault')
  }),
  'small': stylesFromMap({
    height: selectFromTheme('sizeAvatarSmallDefault'),
    width: selectFromTheme('sizeAvatarSmallDefault')
  }),
  'x-small': stylesFromMap({
    // eslint-disable-line @typescript-eslint/naming-convention
    height: selectFromTheme('sizeAvatarExtraSmallDefault'),
    width: selectFromTheme('sizeAvatarExtraSmallDefault')
  })
}), selectFromMap(selectFromProps('$shape'), {
  round: stylesFromMap({
    'border-radius': selectFromTheme('borderRadiusRoundAvatarDefault') // eslint-disable-line @typescript-eslint/naming-convention
  }),

  square: stylesFromMap({
    'border-radius': selectFromTheme('borderRadiusSquareAvatarDefault') // eslint-disable-line @typescript-eslint/naming-convention
  })
}), avatarImgClassName);

/**
 * Displays an avatar for a person or entity.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { Avatar } from '@thisisbud/bui-react-avatar'
 *
 * function Example() {
 *   return <Avatar label='Bank of Bud' src='https://assets.thisisbud.com/openbanking/bud-bank-logo.png'/>
 * }
 * ```
 */
function Avatar(props) {
  const {
    className,
    label,
    shape,
    size,
    src
  } = props;
  return /*#__PURE__*/jsx(StyledSpan, {
    $shape: shape,
    $size: size,
    className: classnames(avatarClassName, className),
    children: /*#__PURE__*/jsx("img", {
      alt: label,
      className: avatarImgClassName,
      src: src
    })
  });
}
Avatar.defaultProps = {
  shape: 'round',
  size: 'regular'
};
Avatar.displayName = 'Avatar';

export { Avatar, avatarClassName };
